import BackgroundImages from '../assets/img/bg/background images.png';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label,Row,Col } from 'reactstrap';
import './Authform.css';
import logoqa from '../assets/img/logo/icon2.png';
import { useHistory } from 'react-router-dom';
import axios from '../axios';
import { useStateValue } from '../StateProvider';
import SweetAlert from "react-bootstrap-sweetalert"
import {
  Alert,
  Snackbar,
 
} from '@mui/material';

import { Data } from 'victory';
import toastr from "toastr"
function AuthForm({}) {
  useEffect(() => {
  
  if (new Date().getMonth() < 3) {
 
    setFInalyear(
      (new Date().getFullYear() - 1).toString() + "-"
      +new Date().getFullYear().toString(),
    )
  } else {
    setFInalyear(
      new Date().getFullYear().toString() +
        "-" +
        (new Date().getFullYear() + 1).toString(),
    )
    
  }

  const firstday = new Date().getFullYear() - 1
  const secondday = new Date().getFullYear()
  const Finalyear = firstday.toString() + "-" + secondday.toString()
  localStorage.setItem("FInalyear", FInalyear.toString())
  }, [])
  const [openLoader, setOpenLoader] = useState(false);
  const history = useHistory();
  const [username, setusername] = useState('');
  const [password, setpassword] = useState('');
  const [userdata, setuserdata] = useState([]);
  const [userinfo, setuserinfo] = useState({});
  const [open, setopen] = useState(false);
  const [user, dispatch] = useStateValue();
  
  const [Compnayid, setCompnayid] = useState("")
  const [CompanyCollection, setCompanyCollection] = useState([])
  const [FInalyear, setFInalyear] = useState("")
  const [qauserflg, setqauserflg] = useState(false)
  const [Qauservalue, setQauservalue] = useState("")
  const [Invalieusernameandpassword, setInvalieusernameandpassword] =
    useState(false)

  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ",
  )
  const GetallCompany = async Usercodevalue => {
    const Getcom = await axios.instance
      .post(
        "/GetCompanyLogUsercode",
        {
          UserCode: Usercodevalue,
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        },
      )
      .then(res => {
   
        if (res.data.length != 0) {
        

          const currentYear = new Date().getFullYear()

        
          if (new Date().getMonth() < 3) {
           
            setFInalyear(
              (new Date().getFullYear() - 1).toString() + "-"
              +new Date().getFullYear().toString(),
            )
          } else {
            setFInalyear(
              new Date().getFullYear().toString() +
                "-" +
                (new Date().getFullYear() + 1).toString(),
            )
           
          }

          const firstday = new Date().getFullYear() - 1
          const secondday = new Date().getFullYear()
          const Finalyear = firstday.toString() + "-" + secondday.toString()
          localStorage.setItem("FInalyear", FInalyear.toString())
      
          setCompanyCollection(res.data)
          let Companycollection = []
          Companycollection.push(res.data[0])
          for (const Data of Companycollection) {
       
            setCompnayid(Data.CompanyId)
        
            localStorage.setItem('CompanyName',Data.Company)
            localStorage.setItem("ShortCodeName", Data.ShortCode)
            localStorage.setItem("CompanyId", Data.CompanyId)
            localStorage.setItem("weeklyof", Data.WeeklyOff)
          }
        } else {
          setCompanyCollection([])
        }
      })
  }
  

  const getqausers = async Usercodevalue => {
    const Getcom = await axios.instance
      .post(
        "/getqausers",
        {
          LoginCode: Usercodevalue,
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        },
      )
      .then(res => {
        if (res.data.length != 0) {
   for (const data of res.data) {
    localStorage.setItem('Qauser',data.QAuser)
    setQauservalue(data.QAuser)
    if(data.QAuser =='Y'){
      setqauserflg(false)
    }else {
      setqauserflg(true)
    }
   }
  }else
  {
    setqauserflg(false)

  }
       
        

      })
  }
  const [notDelete, setnotDelete] = useState(false);
const [companyerror, setcompanyerror] = useState(false)
  const handleCloseNot = async () => {
    setnotDelete(false);
    setOpenLoader(false);
  };
  const handleCloseNot1 = async () => {
    setcompanyerror(false);
    setOpenLoader(false);
  };

  const Getfinalyer = value => {
    setFInalyear(value)
    localStorage.setItem("FInalyear", value)
  }
  const login = async e => {
    e.preventDefault();
    const logidata = await axios.instance
      .post('/login', {
        LoginName: username,
        Password: password,
      })
      .then( async res => {

        if (Object.keys(res.data).length === 2) {
          localStorage.setItem('user', JSON.stringify(res.data));

          setuserdata(res.data.eventlist);
          localStorage.setItem('authtoken', 'Bearer ' + res.data.token);
        }
        for (const data of res.data.eventlist) {
          localStorage.setItem('masterrequired', data.Masterrequired);
           localStorage.setItem('Assignee', data.Assignee);
          localStorage.setItem('Loadall_Ipo', data.Loadall_Ipo);
        }
        if (res.data.eventlist.length === 1 && CompanyCollection.length != 0) {
        for (const data of res.data.eventlist) {
          localStorage.setItem("isAuthProtected", "true")
          const getuserscreen = await axios.instance
            .get(
              `/GetUserScreenRights/${data.UserID}`,

              {
                headers: {
                  Authorization: tokent,
                  "Content-Type": "application/json",
                },
              },
            ).then(async(Res)=>{
              
             
                if (Res.data.length == 41) {
                  localStorage.setItem("UserCode", data.LoginCode)
                  localStorage.setItem("username", data.LoginName)
                  localStorage.setItem("email", data.MailId)
                  localStorage.setItem("usertype", data.UserType)
               
                  localStorage.setItem("userid", data.UserID)
         
           
                  const MasterScreens = []
                  MasterScreens.push(Res.data[0])
                  for (const Screenss of MasterScreens) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                   
                  }
                  const MerchanderScreens = []
                  MerchanderScreens.push(Res.data[1])
                  for (const Screenss of MerchanderScreens) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  
                  }
                  const MerchanderScreens2 = []
                  MerchanderScreens2.push(Res.data[2])
                  for (const Screenss of MerchanderScreens2) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens3 = []
                  MerchanderScreens3.push(Res.data[3])
                  for (const Screenss of MerchanderScreens3) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens4 = []
                  MerchanderScreens4.push(Res.data[4])
                  for (const Screenss of MerchanderScreens4) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens5 = []
                  MerchanderScreens5.push(Res.data[5])
                  for (const Screenss of MerchanderScreens5) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens6 = []
                  MerchanderScreens6.push(Res.data[6])
                  for (const Screenss of MerchanderScreens6) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens7 = []
                  MerchanderScreens7.push(Res.data[7])
                  for (const Screenss of MerchanderScreens7) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens8 = []
                  MerchanderScreens8.push(Res.data[8])
                  for (const Screenss of MerchanderScreens8) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens9 = []
                  MerchanderScreens9.push(Res.data[9])
                  for (const Screenss of MerchanderScreens9) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens10 = []
                  MerchanderScreens10.push(Res.data[10])
                  for (const Screenss of MerchanderScreens10) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens11 = []
                  MerchanderScreens11.push(Res.data[11])
                  for (const Screenss of MerchanderScreens11) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens12 = []
                  MerchanderScreens12.push(Res.data[12])
                  for (const Screenss of MerchanderScreens12) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens13 = []
                  MerchanderScreens13.push(Res.data[13])
                  for (const Screenss of MerchanderScreens13) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens14 = []
                  MerchanderScreens14.push(Res.data[14])
                  for (const Screenss of MerchanderScreens14) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens15 = []
                  MerchanderScreens15.push(Res.data[15])
                  for (const Screenss of MerchanderScreens15) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens16 = []
                  MerchanderScreens16.push(Res.data[16])
                  for (const Screenss of MerchanderScreens16) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens17 = []
                  MerchanderScreens17.push(Res.data[17])
                  for (const Screenss of MerchanderScreens17) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens18 = []
                  MerchanderScreens18.push(Res.data[18])
                  for (const Screenss of MerchanderScreens18) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens19 = []
                  MerchanderScreens19.push(Res.data[19])
                  for (const Screenss of MerchanderScreens19) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens20 = []
                  MerchanderScreens20.push(Res.data[20])
                  for (const Screenss of MerchanderScreens20) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens21 = []
                  MerchanderScreens21.push(Res.data[21])
                  for (const Screenss of MerchanderScreens21) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens22 = []
                  MerchanderScreens22.push(Res.data[22])
                  for (const Screenss of MerchanderScreens22) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens23 = []
                  MerchanderScreens23.push(Res.data[23])
                  for (const Screenss of MerchanderScreens23) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens24 = []
                  MerchanderScreens24.push(Res.data[24])
                  for (const Screenss of MerchanderScreens24) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens25 = []
                  MerchanderScreens25.push(Res.data[25])
                  for (const Screenss of MerchanderScreens25) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens26 = []
                  MerchanderScreens26.push(Res.data[26])
                  for (const Screenss of MerchanderScreens26) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens27 = []
                  MerchanderScreens27.push(Res.data[27])
                  for (const Screenss of MerchanderScreens27) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens28 = []
                  MerchanderScreens28.push(Res.data[28])
                  for (const Screenss of MerchanderScreens28) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens29 = []
                  MerchanderScreens29.push(Res.data[29])
                  for (const Screenss of MerchanderScreens29) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens30 = []
                  MerchanderScreens30.push(Res.data[30])
                  for (const Screenss of MerchanderScreens30) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens31 = []
                  MerchanderScreens31.push(Res.data[31])
                  for (const Screenss of MerchanderScreens31) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens32 = []
                  MerchanderScreens32.push(Res.data[32])
                  for (const Screenss of MerchanderScreens32) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens33 = []
                  MerchanderScreens33.push(Res.data[33])
                  for (const Screenss of MerchanderScreens33) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens34 = []
                  MerchanderScreens34.push(Res.data[34])
                  for (const Screenss of MerchanderScreens34) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens35 = []
                  MerchanderScreens35.push(Res.data[35])
                  for (const Screenss of MerchanderScreens35) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens36 = []
                  MerchanderScreens36.push(Res.data[36])
                  for (const Screenss of MerchanderScreens36) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens37 = []
                  MerchanderScreens37.push(Res.data[37])
                  for (const Screenss of MerchanderScreens37) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
  
                  const MerchanderScreens38 = []
                  MerchanderScreens38.push(Res.data[38])
                  for (const Screenss of MerchanderScreens38) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens39 = []
                  MerchanderScreens39.push(Res.data[39])
                  for (const Screenss of MerchanderScreens39) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens40 = []
                  MerchanderScreens40.push(Res.data[40])
                  for (const Screenss of MerchanderScreens40) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                
                
                  // Res.data.forEach(data => {
                  //   localStorage.setItem(data.MenuName, data.UserModuleId);
                  // });
                 } else {
                  setnotDelete(true)
                  setTimeout(() => {
                    setnotDelete(false) 
                  }, 2000);
                   toastr.error("Login", "Please Contact Administrator")
                 }
                
            
            })
            
            dispatch({
              type: 'SET_USER',
              user: res.data,
            });
            localStorage.setItem('LoggedIn', 'Yes');
            // if (localStorage.getItem("Dashboard")) {
            //   history.push('/dashboard');
            // } else {
            //   setnotDelete(true)
            // }


            if (localStorage.getItem("Dashboard")) {
              history.push("/Dashboard")
            } else if (
              localStorage.getItem("Merchandising") &&
              localStorage.getItem("BuyerOrder")
            ) {
              history.push("/BuyerOrder")
            } else if (
              localStorage.getItem("Merchandising") &&
              localStorage.getItem("WorkOrder")
            ) {
              history.push("/Workorderview")
            } else if (
              localStorage.getItem("InspectionList")  &&
              localStorage.getItem("InspectionList")
            ) {
              history.push("/inspectionModify")
            
            }else{
              setnotDelete(true)
            }
            setTimeout(() => {
              setopen(false);
            }, 2000);
         
        }
      }
      else {
        if (res.data.eventlist.length != 1) {

          setInvalieusernameandpassword(true)

        } else 
        
        if (CompanyCollection.length === 0) {
     
          setcompanyerror(true)
          setTimeout(() => {
            setcompanyerror(false);
          }, 2000);
        }
      }
      });
  };

  const login1 = async e => {
    e.preventDefault();
    const logidata = await axios.instance
      .post('/login', {
        LoginName: username,
        Password: password,
      })
      .then( async res => {

        if (Object.keys(res.data).length === 2) {
          localStorage.setItem('user', JSON.stringify(res.data));

          setuserdata(res.data.eventlist);
          localStorage.setItem('authtoken', 'Bearer ' + res.data.token);
        }
        for (const data of res.data.eventlist) {
          localStorage.setItem('masterrequired', data.Masterrequired);
           localStorage.setItem('Assignee', data.Assignee);
          localStorage.setItem('Loadall_Ipo', data.Loadall_Ipo);
        }
        if (res.data.eventlist.length === 1 ) {
        for (const data of res.data.eventlist) {
          localStorage.setItem("isAuthProtected", "true")
          const getuserscreen = await axios.instance
            .get(
              `/GetUserScreenRights/${data.UserID}`,

              {
                headers: {
                  Authorization: tokent,
                  "Content-Type": "application/json",
                },
              },
            ).then(async(Res)=>{
              
             
                if (Res.data.length == 41) {
                  localStorage.setItem("UserCode", data.LoginCode)
                  localStorage.setItem("username", data.LoginName)
                  localStorage.setItem("email", data.MailId)
                  localStorage.setItem("usertype", data.UserType)
               
                  localStorage.setItem("userid", data.UserID)
         
           
                  const MasterScreens = []
                  MasterScreens.push(Res.data[0])
                  for (const Screenss of MasterScreens) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                   
                  }
                  const MerchanderScreens = []
                  MerchanderScreens.push(Res.data[1])
                  for (const Screenss of MerchanderScreens) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  
                  }
                  const MerchanderScreens2 = []
                  MerchanderScreens2.push(Res.data[2])
                  for (const Screenss of MerchanderScreens2) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens3 = []
                  MerchanderScreens3.push(Res.data[3])
                  for (const Screenss of MerchanderScreens3) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens4 = []
                  MerchanderScreens4.push(Res.data[4])
                  for (const Screenss of MerchanderScreens4) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens5 = []
                  MerchanderScreens5.push(Res.data[5])
                  for (const Screenss of MerchanderScreens5) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens6 = []
                  MerchanderScreens6.push(Res.data[6])
                  for (const Screenss of MerchanderScreens6) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens7 = []
                  MerchanderScreens7.push(Res.data[7])
                  for (const Screenss of MerchanderScreens7) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens8 = []
                  MerchanderScreens8.push(Res.data[8])
                  for (const Screenss of MerchanderScreens8) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens9 = []
                  MerchanderScreens9.push(Res.data[9])
                  for (const Screenss of MerchanderScreens9) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens10 = []
                  MerchanderScreens10.push(Res.data[10])
                  for (const Screenss of MerchanderScreens10) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens11 = []
                  MerchanderScreens11.push(Res.data[11])
                  for (const Screenss of MerchanderScreens11) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens12 = []
                  MerchanderScreens12.push(Res.data[12])
                  for (const Screenss of MerchanderScreens12) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens13 = []
                  MerchanderScreens13.push(Res.data[13])
                  for (const Screenss of MerchanderScreens13) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens14 = []
                  MerchanderScreens14.push(Res.data[14])
                  for (const Screenss of MerchanderScreens14) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens15 = []
                  MerchanderScreens15.push(Res.data[15])
                  for (const Screenss of MerchanderScreens15) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens16 = []
                  MerchanderScreens16.push(Res.data[16])
                  for (const Screenss of MerchanderScreens16) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens17 = []
                  MerchanderScreens17.push(Res.data[17])
                  for (const Screenss of MerchanderScreens17) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens18 = []
                  MerchanderScreens18.push(Res.data[18])
                  for (const Screenss of MerchanderScreens18) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens19 = []
                  MerchanderScreens19.push(Res.data[19])
                  for (const Screenss of MerchanderScreens19) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens20 = []
                  MerchanderScreens20.push(Res.data[20])
                  for (const Screenss of MerchanderScreens20) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens21 = []
                  MerchanderScreens21.push(Res.data[21])
                  for (const Screenss of MerchanderScreens21) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens22 = []
                  MerchanderScreens22.push(Res.data[22])
                  for (const Screenss of MerchanderScreens22) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens23 = []
                  MerchanderScreens23.push(Res.data[23])
                  for (const Screenss of MerchanderScreens23) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens24 = []
                  MerchanderScreens24.push(Res.data[24])
                  for (const Screenss of MerchanderScreens24) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens25 = []
                  MerchanderScreens25.push(Res.data[25])
                  for (const Screenss of MerchanderScreens25) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens26 = []
                  MerchanderScreens26.push(Res.data[26])
                  for (const Screenss of MerchanderScreens26) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens27 = []
                  MerchanderScreens27.push(Res.data[27])
                  for (const Screenss of MerchanderScreens27) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens28 = []
                  MerchanderScreens28.push(Res.data[28])
                  for (const Screenss of MerchanderScreens28) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens29 = []
                  MerchanderScreens29.push(Res.data[29])
                  for (const Screenss of MerchanderScreens29) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens30 = []
                  MerchanderScreens30.push(Res.data[30])
                  for (const Screenss of MerchanderScreens30) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens31 = []
                  MerchanderScreens31.push(Res.data[31])
                  for (const Screenss of MerchanderScreens31) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens32 = []
                  MerchanderScreens32.push(Res.data[32])
                  for (const Screenss of MerchanderScreens32) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens33 = []
                  MerchanderScreens33.push(Res.data[33])
                  for (const Screenss of MerchanderScreens33) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens34 = []
                  MerchanderScreens34.push(Res.data[34])
                  for (const Screenss of MerchanderScreens34) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens35 = []
                  MerchanderScreens35.push(Res.data[35])
                  for (const Screenss of MerchanderScreens35) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens36 = []
                  MerchanderScreens36.push(Res.data[36])
                  for (const Screenss of MerchanderScreens36) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens37 = []
                  MerchanderScreens37.push(Res.data[37])
                  for (const Screenss of MerchanderScreens37) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
  
                  const MerchanderScreens38 = []
                  MerchanderScreens38.push(Res.data[38])
                  for (const Screenss of MerchanderScreens38) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens39 = []
                  MerchanderScreens39.push(Res.data[39])
                  for (const Screenss of MerchanderScreens39) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                  const MerchanderScreens40 = []
                  MerchanderScreens40.push(Res.data[40])
                  for (const Screenss of MerchanderScreens40) {
                    //////console.log(Screenss.MenuName)
                    if(Screenss.Visible == 'Y'){
                      localStorage.setItem(Screenss.MenuName, Screenss.UserModuleId)
                    }
                  }
                
                
                  // Res.data.forEach(data => {
                  //   localStorage.setItem(data.MenuName, data.UserModuleId);
                  // });
                 } else {
                  setnotDelete(true)
                  setTimeout(() => {
                    setnotDelete(false) 
                  }, 2000);
                   toastr.error("Login", "Please Contact Administrator")
                 }
                
            
            })
            
            dispatch({
              type: 'SET_USER',
              user: res.data,
            });
            localStorage.setItem('LoggedIn', 'Yes');
            // if (localStorage.getItem("Dashboard")) {
            //   history.push('/dashboard');
            // } else {
            //   setnotDelete(true)
            // }
            history.push("/inspectionModify")

            // if (localStorage.getItem("Dashboard")) {
            //   history.push("/Dashboard")
            // } else if (
            //   localStorage.getItem("Merchandising") &&
            //   localStorage.getItem("BuyerOrder")
            // ) {
            //   history.push("/BuyerOrder")
            // } else if (
            //   localStorage.getItem("Merchandising") &&
            //   localStorage.getItem("WorkOrder")
            // ) {
            //   history.push("/Workorderview")
            // } else if (
            //   localStorage.getItem("InspectionList")  &&
            //   localStorage.getItem("InspectionList")
            // ) {
            //   history.push("/inspectionModify")
            
            // }else{
            //   setnotDelete(true)
            // }
            setTimeout(() => {
              setopen(false);
            }, 2000);
         
        }
      }
      else {
        if (res.data.eventlist.length != 1) {

          setInvalieusernameandpassword(true)

        } 
      }
      });
  };
  useEffect(() => {
    localStorage.setItem('cateid', 0);
  }, []);

  const companyidvalue = async value => {
    setCompnayid(value)

    localStorage.setItem("CompanyId", value)
    // localStorage.setItem('CompanyName', la) GetOneCompany
    const Getcom = await axios.instance
      .get(
        `/GetOneCompany/${value}`,
        {},
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        },
      )
      .then(res => {
        //console.log(res.data, "da")
        let Companycollection = []
        Companycollection.push(res.data[0])
        for (const Data of Companycollection) {
          //// console.log('CompanyName',Data.Company)
          localStorage.setItem("ShortCodeName", Data.ShortCode)
          localStorage.setItem("CompanyName", Data.Company)
          localStorage.setItem("CompanyId", Data.CompanyId)
        }
      })
  }
  return (
    <div>
      <div className="authpage">
        <div className="cardlogin">
          {localStorage.getItem('Qauser') == 'N' ? (
               <Form onSubmit={login}



               >
                 <div className="text-center pb-4">
                   <img
                     src={logoqa}
                     height="180px"
                     width="180px"
                     style={{ objectFit: 'contain' }}
                     alt='imagie'
                   />
                   <h1>
                     {/* <b>PADMA</b> */}
                   </h1>{' '}
                   {/* Inspection */}
                 </div>
     
                 <FormGroup>
                   <Label>User Code</Label>
                   <Input
                     value={username}
                     placeholder="User Code"
                     onChange={e =>{
                       GetallCompany(e.target.value)
                       getqausers(e.target.value)
                       setusername(e.target.value)
                     } }
                   />
                   {open ? <p className="errors">Invalid username</p> : ''}
                 </FormGroup>
                 <FormGroup>
                   <Label>Password</Label>
                   <Input
                     type="password"
                     value={password}
                     placeholder="Password"
                     onChange={e => setpassword(e.target.value)}
                   />
                   {open ? <p className="errors">Invalid password </p> : ''}
                 </FormGroup>
                 {/* <hr /> */}
                 {qauserflg == true ? (
     
              
                 <Row className="mt-2">
                         <Col lg={6}>
                           <div className="mb-4">
                             <Label
                               className="form-label"
                               style={{
                                 fontFamily: "sans-serif",
                                 fontWeight: "bolder",
                               }}
                             >
                               Company
                             </Label>
                             <Input
                               value={Compnayid}
                               type="select"
                               onChange={e => {
                                 companyidvalue(e.target.value)     //console.log(e.target.value, "Company")
                               }}
                             >
                               <option value="" disabled selected>
                                 Select{" "}
                               </option>
                               {CompanyCollection.map((data, index) => (
                                 <option key={index} value={data.CompanyId}>
                                   {data.Company}{" "}
                                 </option>
                               ))}
                             </Input>
                           </div>
                         </Col>
                         <Col lg={6}>
                           <div className="mb-4">
                             <Label
                               className="form-label"
                               style={{
                                 fontFamily: "sans-serif",
                                 fontWeight: "bolder",
                               }}
                             >
                               Financial year
                             </Label>
                             <Input
                               value={FInalyear}
                               type="select"
                               onChange={e => Getfinalyer(e.target.value)}
                             >
                               <option>Select Financial year </option>
                               <option value="2021-2022"> 2021-2022 </option>
                               <option value="2022-2023"> 2022-2023 </option>
                               <option value="2023-2024"> 2023-2024 </option>
                               <option value="2024-2025"> 2024-2025 </option>
                               <option value="2025-2026"> 2025-2026 </option>
                               <option value="2026-2027"> 2026-2027 </option>
                               <option value="2027-2028"> 2027-2028 </option>
                               <option value="2028-2029"> 2028-2029 </option>
                               <option value="2029-2030"> 2029-2030 </option>
                               <option value="2030-2031"> 2030-2031 </option>
                               <option value="2031-2032"> 2031-2032 </option>
                               <option value="2032-2033"> 2032-2033 </option>
                               <option value="2033-2034"> 2033-2034 </option>
                             </Input>
                           </div>
                         </Col>
                       </Row>   ):null}
     
                 <Button size="lg" className="bg-gradient-success border-0 mt-10 pt-20" block>
                   Login
                 </Button>
     
                 {/* {userdata.length != 0
                   ? userdata.map(
                       data => (
                         localStorage.setItem('userid', data.UserID),
                         localStorage.setItem('username', data.LoginName),
                         localStorage.setItem('email', data.EmailId),
                         localStorage.setItem('usertype', data.UserType)
                       ),
                     )
                   : ''} */}
               </Form>
          ):
          <Form onSubmit={login1}



          >
            <div className="text-center pb-4">
              <img
                src={logoqa}
                height="180px"
                width="180px"
                style={{ objectFit: 'contain' }}
                alt='imagie'
              />
              <h1>
                {/* <b>PADMA</b> */}
              </h1>{' '}
              {/* Inspection */}
            </div>

            <FormGroup>
              <Label>User Code</Label>
              <Input
                value={username}
                placeholder="User Code"
                onChange={e =>{
                  GetallCompany(e.target.value)
                  getqausers(e.target.value)
                  setusername(e.target.value)
                } }
              />
              {open ? <p className="errors">Invalid username</p> : ''}
            </FormGroup>
            <FormGroup>
              <Label>Password</Label>
              <Input
                type="password"
                value={password}
                placeholder="Password"
                onChange={e => setpassword(e.target.value)}
              />
              {open ? <p className="errors">Invalid password </p> : ''}
            </FormGroup>
            {/* <hr /> */}
            {qauserflg == true ? (

         
            <Row className="mt-2">
                    <Col lg={6}>
                      <div className="mb-4">
                        <Label
                          className="form-label"
                          style={{
                            fontFamily: "sans-serif",
                            fontWeight: "bolder",
                          }}
                        >
                          Company
                        </Label>
                        <Input
                          value={Compnayid}
                          type="select"
                          onChange={e => {
                            companyidvalue(e.target.value)     //console.log(e.target.value, "Company")
                          }}
                        >
                          <option value="" disabled selected>
                            Select{" "}
                          </option>
                          {CompanyCollection.map((data, index) => (
                            <option key={index} value={data.CompanyId}>
                              {data.Company}{" "}
                            </option>
                          ))}
                        </Input>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-4">
                        <Label
                          className="form-label"
                          style={{
                            fontFamily: "sans-serif",
                            fontWeight: "bolder",
                          }}
                        >
                          Financial year
                        </Label>
                        <Input
                          value={FInalyear}
                          type="select"
                          onChange={e => Getfinalyer(e.target.value)}
                        >
                          <option>Select Financial year </option>
                          <option value="2021-2022"> 2021-2022 </option>
                          <option value="2022-2023"> 2022-2023 </option>
                          <option value="2023-2024"> 2023-2024 </option>
                          <option value="2024-2025"> 2024-2025 </option>
                          <option value="2025-2026"> 2025-2026 </option>
                          <option value="2026-2027"> 2026-2027 </option>
                          <option value="2027-2028"> 2027-2028 </option>
                          <option value="2028-2029"> 2028-2029 </option>
                          <option value="2029-2030"> 2029-2030 </option>
                          <option value="2030-2031"> 2030-2031 </option>
                          <option value="2031-2032"> 2031-2032 </option>
                          <option value="2032-2033"> 2032-2033 </option>
                          <option value="2033-2034"> 2033-2034 </option>
                        </Input>
                      </div>
                    </Col>
                  </Row>   ):null}

            <Button size="lg" className="bg-gradient-success border-0 mt-10 pt-20" block>
              Login
            </Button>

            {/* {userdata.length != 0
              ? userdata.map(
                  data => (
                    localStorage.setItem('userid', data.UserID),
                    localStorage.setItem('username', data.LoginName),
                    localStorage.setItem('email', data.EmailId),
                    localStorage.setItem('usertype', data.UserType)
                  ),
                )
              : ''} */}
          </Form>
        
        }
         
          <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={notDelete}
              autoHideDuration={3000}
              onClose={handleCloseNot}
            >
              <Alert onClose={handleCloseNot} severity="warning">
              Login! Please Contact Administrator
              </Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={companyerror}
              autoHideDuration={3000}
              onClose={handleCloseNot1}
            >
              <Alert onClose={handleCloseNot1} severity="warning">
              Company Not Assigned! Please Contact Administrator
              </Alert>
            </Snackbar>
            {Invalieusernameandpassword ? (
        <SweetAlert
          title="Invalid User Name and Password"
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setInvalieusernameandpassword(false)
          }}
        >
          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-info btn-lg ms-2"
              onClick={() => setInvalieusernameandpassword(false)}
            >
              Close
            </button>
          </div>
        </SweetAlert>
      ) : null}
        </div>
      </div>
    </div>
  );
}
export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  onLogoClick: () => {},
};
export default AuthForm;
